<template>
	<div class="app-wrapper">
		<cheader></cheader>
		<div class="main-wrap">
			<div class="main">
				<div class="tab">
					{{ id ? '商品详情编辑' : '自营创建商品' }}
					<div>
						<el-button
							type="primary"
							icon="el-icon-arrow-left"
							@click="onCloseClick"
							plain
							>返回</el-button
						>
						<el-button
							type="primary"
							icon="el-icon-refresh-left"
							@click="onClearFormClick"
							plain
							>刷新</el-button
						>
					</div>
				</div>
				<div class="step-container">
					<div :class="{ step: true, active: step >= 0 }">商品基本信息</div>
					<div :class="{ step: true, active: step >= 1 }">商品属性信息</div>
					<div :class="{ step: true, active: step >= 2 }">商品详情信息</div>
				</div>

				<div class="setting-container" v-loading="loadData">
					<BaseSetting
						v-show="step === 0"
						@on-success="onSettingSuccess"
						:goodsData="goodsData"
						:formData.sync="form0"
						ref="setting0"
					/>
					<FieldSetting
						v-show="step === 1"
						@on-success="onSettingSuccess"
						:goodsData="goodsData"
						:formData.sync="form1"
						ref="setting1"
					/><DetailSetting
						v-show="step === 2"
						@on-success="onSettingSuccess"
						:goodsData="goodsData"
						:formData.sync="form2"
						ref="setting2"
					/>
				</div>
			</div>
			<div class="btns">
				<el-button v-show="step > 0" type="primary" @click="onLastStepClick"
					>上一步，{{ id ? '编辑' : '填写' }}商品{{
						step === 2 ? '属性' : '基本信息'
					}}</el-button
				>
				<el-button type="primary" @click="onNextStepClick" :loading="loading">{{
					step === 2
						? '保存提交'
						: `下一步，${id ? '编辑' : '填写'}${
								step === 0 ? '商品属性' : '商品详情展示'
						  }`
				}}</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import cheader from '../../layout/components/cheader'
import BaseSetting from './baseSetting'
import FieldSetting from './fieldSetting'
import DetailSetting from './detailSetting'
import { createGoods, updateGoods, getGoodsInfo } from '@/api/goods'
export default {
	components: { cheader, BaseSetting, FieldSetting, DetailSetting },
	data() {
		return {
			id: '',
			// 0:基本设置，1:属性设置，2:详情设置
			step: 0,
			form0: {},
			form1: {},
			form2: {},
			goodsData: null,
			loadData: false,
			loading: false
		}
	},
	created() {
		this.id = this.$route.query.id
		this.getGoodsData()
	},
	methods: {
		//关闭窗口
		onCloseClick() {
			window.opener = null
			window.open('', '_self')
			window.close()
		},
		//清除当前step的form
		onClearFormClick() {
			this.$refs[`setting${this.step}`].clearForm()
		},
		onLastStepClick() {
			this.step--
		},
		onNextStepClick() {
			this.$refs[`setting${this.step}`].checkForm()
		},
		getGoodsData() {
			if (this.id) {
				this.loadData = true
				getGoodsInfo(this.id)
					.then(res => {
						this.loadData = false
						this.goodsData = res
					})
					.catch(e => {
						this.loadData = false
						console.log(e)
					})
			}
		},
		onSettingSuccess() {
			if (this.step !== 2) {
				this.step++
				return
			}
			this.processData()
		},
		async processData() {
			const form = Object.assign(
				this.id ? { id: this.id } : {},
				this.form0,
				this.form1,
				this.form2
			)
			if (!form.cate_id) {
				form.cate_id = form.parent_id
			}
			try {
				this.loading = true
				this.id ? await updateGoods(form) : await createGoods(form)
				this.$message.success(`${this.id ? '编辑' : '创建'}成功`)
				setTimeout(() => {
					this.onCloseClick()
				}, 1500)
			} finally {
				this.loading = false
			}
		}
	}
}
</script>
<style lang="scss" scoped>
@import 'src/styles/mixin.scss';
@import 'src/styles/element-variables.scss';
.app-wrapper {
	@include clearfix;
	height: 100%;
	background-color: #f1f5fb;
	min-width: 1200px;
	.main-wrap {
		height: 100%;
		padding-top: 72px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		.main {
			flex: 1;
			overflow: auto;
			padding: 0 20px;
			.tab {
				height: 62px;
				border-radius: 8px;
				background-color: #fff;
				position: relative;
				padding: 0 30px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin: 20px 0;
				font-size: 16px;
				color: #666;
				&::after {
					position: absolute;
					content: '';
					top: 50%;
					transform: translateY(-50%);
					left: 18px;
					width: 6px;
					height: 20px;
					background-color: $--color-primary;
				}
			}
			.step-container {
				height: 50px;
				margin-bottom: 20px;
				display: flex;
				justify-content: center;
				.step {
					width: 400px;
					display: flex;
					justify-content: center;
					align-items: center;
					background-color: #fff;
					font-size: 16px;
					color: #666;
					position: relative;
					margin-right: 36px;
					&.active {
						background-color: $--color-primary;
						color: #fff;
						&::after {
							border-left-color: $--color-primary;
						}
						&::before {
							border-top-color: $--color-primary !important;
							border-bottom-color: $--color-primary !important;
						}
					}
					&:not(:first-child) {
						&::before {
							content: '';
							position: absolute;
							left: -18px;
							top: 0;
							height: 0;
							width: 0;
							border-left: 18px solid transparent;
							border-top: 25px solid #fff;
							border-bottom: 25px solid #fff;
						}
					}

					&::after {
						content: '';
						position: absolute;
						right: -18px;
						top: 0;
						height: 0;
						width: 0;
						border-left: 18px solid #fff;
						border-top: 25px solid transparent;
						border-bottom: 25px solid transparent;
					}
				}
			}
			.setting-container {
				background-color: #fff;
				border-radius: 8px;
				padding: 24px 0;
			}
		}
		.btns {
			background-color: #fff;
			border-top: 1px solid #ddd;
			padding: 12px 0;
		}
	}
}
</style>
